import {TranslateService} from '@ngx-translate/core';
import {Filter} from '@domain/common/list-view';

import {AutocompleteOptions} from '../autocomplete';

/**
 * Options des unités d'une distance
 */
export default class UniteDistanceOptions implements AutocompleteOptions {
	/**
	 * Récupération de l'URL
	 */
	url() {
		//URL
		return `/controller/Adresse/getUnitesDistance`;
	}

	/**
	 * Affichage d'un élément
	 */
	displayItem(item: any) {
		return (item?.libelle ? item.libelle : '');
	}

	/**
	 * Filtres disponibles
	 */
	listeFilters(translateService: TranslateService): Array<Filter> {
		//Retour de la liste des filtres
		return [{
			title: translateService.instant('filter.libelle'),
			clef: 'libelle',
			isDefault: true
		}]
	}
}